/**
 * 受発注入力グループ画面
*/
import React, { useEffect, useRef, useState } from "react";
import { observer } from "mobx-react";

const Inff001 = observer((props) => {
    // sample
    const onClose = () => {
        props.close({ "code": '123', "name": 'test', "row": '1' });
    };
    //子コンポーネントにinputdataの各オブジェクトごと渡した方がすっきりする気がするけど、
    //コンポーネントの種類によって渡したいデータ異なるので、冗長だけどhtmlに指定していく
    return (
        <div>
            {/* 登録済かで切り替える */}
            <div>
                <button onClick={onClose} className="btn btn-success">button</button>
            </div>
        </div >
    );
});

export default Inff001;
